import { useContext, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { PurchaseDocumentDataForm} from '../../../app/models/PurchaseDocument';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import PurchaseDocumentDetailDataTable from './tables/PurchaseDocumentDetailDataTable';
import { PurchaseDocumentDetail, PurchaseDocumentDetailFilters } from '../../../app/models/PurchaseDocumentDetail';
import { PaymentStatusDataForm, PaymentStatusesStatus, PaymentStatusFilters } from '../../../app/models/PaymentStatus';
import PaymentStatusDataTable from '../../PaymentStatus/components/tables/PaymentStatusDataTable';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import DefaultCard from '../../../components/default/DefaultCard';
import DefaultModal from '../../../components/default/DefaultModal';
import PurchaseDocumentsEdit from './PurchaseDocumentEdit';
import DefaultToolBar from '../../../components/default/DefaultToolBar';
import ButtonCreate from '../../../components/buttons/ButtonCreate';
import { PurchaseDocumentHistoryDataForm, PurchaseDocumentHistoryFilters } from '../../../app/models/PurchaseDocumentHistory';
import PurchaseDocumentDetailForm from './forms/PurchaseDocumentDetailForm';
import { PurchaseDocumentStatus } from '../../../app/models/PurchaseDocumentStatus';
import PurchaseDocumentTotal from './PurchaseDocumentTotal';
import DefaultCreatedModifiedUserForm from '../../../components/default/DefaultCreatedModifiedUserForm';
import PurchaseDocumentCondition from './PurchaseDocumentCondition';
import { PurchaseDocumentStatusEnum } from '../../../app/shared/enums';
import LazyLoading from '../../../components/LazyLoading';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import usePurchaseDocumentService from '../../../app/services/hooks/usePurchaseDocumentService';
import usePurchaseDocumentDetailService from '../../../app/services/hooks/usePurchaseDocumentDetailService';
import usePurchaseDocumentHistoryService from '../../../app/services/hooks/usePurchaseDocumentHistoryService';

interface Props {
    purchaseDocumentId: number;
    isShow?: boolean;
    purchaseDocument: PurchaseDocumentDataForm;
    setPurchaseDocument?: (purchaseDocument: PurchaseDocumentDataForm) => void;
    purchaseDocumentForm: PurchaseDocumentDataForm;
    setPurchaseDocumentForm: (purchaseDocumentForm: PurchaseDocumentDataForm) => void;
    setPurchaseDocumentDetailTable?: (purchaseDocumentDetail: PurchaseDocumentDetail[]) => void;
    reloadPurchaseDocumentDetailTable: () => void;
    filterDetail: PurchaseDocumentDetailFilters;
    setFilterDetail: (filter: PurchaseDocumentDetailFilters) => void;
    reloadPurchaseDocument: (purchaseDocumentId: number) => void;
    setPurchaseDocumentHistoryTable: (purchaseDocumentHistory: PurchaseDocumentHistoryDataForm[]) => void;
    filterHistory: PurchaseDocumentHistoryFilters;
    setFilterHistory: (filter: PurchaseDocumentHistoryFilters) => void;
    reloadHistoryTable: () => void;
    reloadDetail:() => void;
    paymentStatuses: PaymentStatusDataForm[];
    setPaymentStatuses?: (paymentStatusesStatus: PaymentStatusDataForm[]) => void;
    paymentStatusesStatus: PaymentStatusesStatus[];
    setPaymentStatusesStatus?: (setPaymentStatusesStatus: PaymentStatusesStatus[]) => void;
    statuses:PurchaseDocumentStatus[];
    setStatuses: (statuses: PurchaseDocumentStatus[]) => void;
    totalRowsDetail: number
    

}

const PurchaseDocumentContainer = ({
    purchaseDocumentId,
    purchaseDocumentForm,
    setPurchaseDocumentDetailTable,
    reloadPurchaseDocumentDetailTable,
    setPurchaseDocumentHistoryTable,
    filterHistory,
    setFilterHistory,
    filterDetail,
    setFilterDetail,
    reloadHistoryTable,
    paymentStatuses,
    statuses,
    paymentStatusesStatus,
    totalRowsDetail,
    setPaymentStatusesStatus,
    setStatuses,
    reloadDetail,
    reloadPurchaseDocument,
    setPurchaseDocumentForm,
    isShow = false,
}: Props) => {

    const [showingEdit, setShowingEdit] = useState(false);
    const [purchaseDocumentDetailIdEdit, setpurchaseDocumentDetailIdEdit] = useState<number>(-1);
    const [purchaseDocumentHistories, setPurchaseDocumentHistories] = useState<PurchaseDocumentHistoryDataForm[]>([]);
    const [errorFields, setErrorFields] = useState<any>();
    const [showingShow, setShowingShow] = useState(false);
    const { showLoading, hideLoading } = useContext(AppContext);
    const { getPurchaseDocumentDetailsByPurchaseDocument, fetchingGetPurchaseDocumentDetailsByPurchaseDocument, 
        deletePurchaseDocumentDetail, fetchingDeletePurchaseDocumentDetailsByPurchaseDocument  } = usePurchaseDocumentDetailService();
    const { getAllPurchaseDocumentHistoriesByInvoice} = usePurchaseDocumentHistoryService();
    const { editPurchaseDocument, fetchingEditPurchaseDocument, showPurchaseDocument, updatePurchaseDocument } = usePurchaseDocumentService();
    const [documentType, setDocumentType] = useState<string | null>(null); 

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando estado de pago...');
        updatePurchaseDocument(purchaseDocumentId, purchaseDocumentForm, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(undefined);
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                reloadPurchaseDocumentDetailTable();
                reloadDetail();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
                toast.error(response.message);
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        }, true); // Pasa `true` como cuarto argumento
    };

    const showEdit = (purchaseDocumentDetailId: number, docType: string) => {
        setShowingEdit(true);
        setDocumentType(docType);
        // console.log(docType)
        setpurchaseDocumentDetailIdEdit(purchaseDocumentDetailId);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setDocumentType(null);
        setpurchaseDocumentDetailIdEdit(-1);
    };


    const hideShow = () => {
        setShowingShow(false);
    };

    

    const destroy = (serviceManifestId: number | null) => {
        const _text = serviceManifestId
            ? `Está a punto de desvincular la hoja de entrada # ${serviceManifestId} de la factura de venta`
            : 'No hay un estado de pago válido para desvincular.';
            
    
        useReactConfirmAlert().requestConfirmation({
            title: '¿Está seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Sí, desvincular',
                    onClick: () => {
                        if (serviceManifestId) {
                            if (showLoading) showLoading('loading', 'Eliminando detalles de documento de compra...');
    
                            deletePurchaseDocumentDetail(purchaseDocumentId, serviceManifestId, {
                                onSuccess: (response: ServiceResponse) => {
                                    if (hideLoading) hideLoading();
                                    useReactConfirmAlert().successAlert({
                                        title: 'Éxito',
                                        message: response.message,
                                    });
                                    reloadPurchaseDocumentDetailTable();
                                    reloadDetail();
                                    reloadHistoryTable();
                                },
                                onError: (response: ServiceResponse) => {
                                    if (hideLoading) hideLoading();
                                    useReactConfirmAlert().errorAlert({
                                        title: 'Error',
                                        message: response.message,
                                    });
                                },
                            });
                        } else {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El estado de pago no se ha desvinculado.',
                            });
                        }
                    }
                },
                cancelButton: {
                    label: 'Cancelar',
                    onClick: () => {
                        setTimeout(() => {
                        useReactConfirmAlert().infoAlert({
                            title: 'Cancelado',
                            message: 'El estado de pago no se ha desvinculado.',
                        });
                    }, 0);
                }
            }
        }
        });
    };

    return (
        <>

                <div className="row">
                        {/* Datos Generales */}
                        <div className="col-md-6">
                        <DefaultCard>
                            <div className="h3 mt-0 mb-2 card-title">Datos Generales</div>
                            {!fetchingEditPurchaseDocument ? (
                                <PurchaseDocumentDetailForm
                                    purchaseDocument={purchaseDocumentForm}
                                    setPurchaseDocument={setPurchaseDocumentForm}
                                    errorFields={errorFields}
                                    disabled={purchaseDocumentForm.status !== PurchaseDocumentStatusEnum.BORRADOR || isShow} // Pasa `true` si no es BORRADOR
                                />
                            ) : (
                                <LazyLoading />
                            )}
                            <hr />
                            <div className="row justify-content-end">
                                {!fetchingEditPurchaseDocument && purchaseDocumentForm.status === PurchaseDocumentStatusEnum.BORRADOR  && !isShow &&(
                                    <div className="col-auto">
                                        <ButtonSaveForm callbackSave={update} locked={fetchingEditPurchaseDocument} />
                                    </div>
                                )}
                            </div>
                        </DefaultCard>
                        </div>

                        {/* Usuarios */}
                        <div className="col-md-6">
                            <div className="card">
                            <div className="card-body">
                            <div className="h3 mt-0 mb-2 card-title">Usuarios</div>
                                {!fetchingEditPurchaseDocument ? (
                                    <DefaultCreatedModifiedUserForm
                                        createdBy={purchaseDocumentForm.created_user}
                                        createdAt={purchaseDocumentForm.created_at}
                                        updatedBy={purchaseDocumentForm.last_modified_user}
                                        updatedAt={purchaseDocumentForm.updated_at}
                                        status={purchaseDocumentForm.status_label}
                                        // status={purchaseDocumentForm.status === PurchaseDocumentStatusEnum.BORRADOR ? 'BORRADOR' : purchaseDocumentForm.status}
                                    />
                                ) : (
                                    <div>Cargando...</div>
                                )}
                            </div>
                            </div>
                        </div>
                    </div>

                    <DefaultCard>

                    <div className="col-12">
                        <PurchaseDocumentCondition
                        purchaseDocument={purchaseDocumentForm}
                        />
                    </div>

                    </DefaultCard>
            
            <DefaultCard>
                <div className="row">
                    <div className="col-12">
                    <DefaultToolBar
                        left={
                            !isShow &&
                            purchaseDocumentForm &&
                            purchaseDocumentForm.status === PurchaseDocumentStatusEnum.BORRADOR &&
                            purchaseDocumentForm.note_type !== 'ANULACION' ? (
                                <ButtonCreate
                                    callbackCreate={() => {
                                        if (purchaseDocumentForm.document_type_obj) {
                                            showEdit(purchaseDocumentDetailIdEdit, String(purchaseDocumentForm.document_type_obj?.id));
                                        } else {
                                            toast.error('El tipo de documento no está definido.');
                                        }
                                    }}
                                    // title={`Agregar posicion de ${purchaseDocumentForm.document_type_obj?.name}`}
                                    title={`Agregar POS`}
                                />
                            ) : null
                        }
                    />
                    </div>

                    <div className="col-12">
                        <PurchaseDocumentDetailDataTable
                            purchaseDocumentDetail={paymentStatuses}
                            totalRows={totalRowsDetail}
                            loading={fetchingGetPurchaseDocumentDetailsByPurchaseDocument}
                            destroy={isShow || purchaseDocumentForm.note_type === "ANULACION" || purchaseDocumentForm.status === PurchaseDocumentStatusEnum.CONTABILIZADA ? undefined : destroy}
                            filter={filterDetail}
                            setFilter={setFilterDetail}
                            statuses={paymentStatusesStatus}
                            callbackSuccess={reloadPurchaseDocumentDetailTable}
                        />
                    </div>
                    <div className="col-12">
                        <PurchaseDocumentTotal
                        purchaseDocument={purchaseDocumentForm}
                        />
                    </div>
                </div>
            </DefaultCard>
    
            {showingEdit ? (
                <DefaultModal
                    show={showingEdit}
                    handleClose={hideEdit}
                    title={`Agregar posicion de ${purchaseDocumentForm.document_type_obj?.name}`}
                    backdrop={true}
                    showFooter={false}
                >
                    <PurchaseDocumentsEdit
                        purchaseDocumentId={Number(purchaseDocumentId)}
                        onSaved={() => {
                            reloadHistoryTable();
                            reloadPurchaseDocumentDetailTable();
                            reloadDetail();
                            hideEdit();
                        }}
                        onError={() => {
                            reloadPurchaseDocumentDetailTable();
                            reloadDetail();
                            hideEdit();
                        }}
                        onCancel={hideEdit}
                        purchaseDocumentDetailId={purchaseDocumentDetailIdEdit}
                        setPurchaseDocumentDetailTable={setPurchaseDocumentDetailTable!}
                        reloadPurchaseDocumentTable={reloadPurchaseDocumentDetailTable}
                        setPurchaseDocumentHistoryTable={setPurchaseDocumentHistoryTable!}
                        // reloadPurchaseDocumentHistoryTable={reloadHistoryTable}
                    />
                </DefaultModal>
            ) : null}

        </>
    );
};

export default PurchaseDocumentContainer;
